// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27w6M","top":"styles_top__2nbYA","left":"styles_left__19Bfj","description":"styles_description__39GoR"};